import styled from 'styled-components';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import { StyledButton } from 'components/Buttons/DefaultButton/DefaultButton.styles';

export const Container = styled.div`
  height: 100%;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  background-color: #fff;
  overflow: auto;

  @media (max-width: 768px) {
    padding-bottom: 5rem;
  }
`;

export const Title = styled.h1`
  text-align: center;
  color: #333;
`;

export const Paragraph = styled.p`
  color: #555;
  line-height: 1.6;
  margin: 1rem 0;
`;

export const Link = styled.a`
  color: #007bff;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export const ButtonContainer = styled.div`
  display:flex;
  flex-direction:column;
  align-items:center;
  margin: 2rem 0;
  @media (max-width: 768px) {
    margin-bottom: 3rem;
  }
`;

export const WarningBox = styled.div`
  background-color: #fff3cd;
  border: 1px solid #ffeeba;
  border-radius: 4px;
  padding: 1rem;
  margin-bottom: 1rem;
  background-color: var(--background-main);
  border: 2px solid var(--primary-main);
  ${Paragraph} {
    margin: 0.5rem 0;
  }
  ul {
    margin: 0.5rem 0;
    padding-left: 1.5rem !important;
  }
  li {
    margin-bottom: 0.5rem;
  }
`;

export const AccountBox = styled.div<{ $backgroundColor: string, $borderColor: string }>`
  background-color: ${props => props.$backgroundColor};
  border: 2px solid ${props => props.$borderColor};
  border-radius: 4px;
  padding: 1rem;
  margin-bottom: 1rem;
  ${Paragraph} {
    margin: 0.5rem 0;
  }
`;

export const BoxTitle = styled.div<{ $titleColor: string }>`
  font-family: Poppins;
  font-size: 20px;
  font-weight: 600;
  line-height: 30px;
  letter-spacing: 0.5px;
  text-align: left;
  color: ${props => props.$titleColor};
`;

export const WarningIcon = styled(WarningAmberOutlinedIcon)<{ $iconColor: string }>`
  color: ${props => props.$iconColor};
`;

export const DeleteStyledButton = styled(StyledButton)`
  max-width:30rem;
`;
